import { ApiUrls } from '../endpoints';
import api from '../createApiClient';

export const getAllCredentials = async () => {
  try {
    const dataUrl = `${ApiUrls.credential}/getAllCredentials`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all credentials:', error);
    throw error;
  }
};

export const getAllCredentialsByIssuer = async (CredentialIssuerID) => {
  try {
    const dataUrl = `${ApiUrls.credential}/getAllCredentialsByIssuerId/${CredentialIssuerID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all credentials:', error);
    throw error;
  }
};

export const getCredential = async (CredentialID) => {
  try {
    const dataUrl = `${ApiUrls.credential}/getCredentialById/${CredentialID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting credential:', error);
    throw error;
  }
};

export const createCredential = async (data) => {
  try {
    const dataUrl = `${ApiUrls.credential}/createCredential`;
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error creating credential:', error);
    throw error;
  }
};

export const updateCredential = async (data) => {
  try {
    const dataUrl = `${ApiUrls.credential}/updateCredentialById`;
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error updating credential:', error);
    throw error;
  }
};

export const deleteCredential = async (CredentialID) => {
  try {
    const dataUrl = `${ApiUrls.credential}/deleteCredentialById/${CredentialID}`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting credential:', error);
    throw error;
  }
};

export const deleteAllCredentials = async () => {
  try {
    const dataUrl = `${ApiUrls.credential}/deleteAllCredentials`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting all credentials:', error);
    throw error;
  }
};
